module.exports = __webpack_public_path__ + "img/yzh1.f1a02a2d.jpg";